import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/ui";
import { Plus } from "lucide-react";
import { type useEventFormDialogContents } from "../../../../../hooks";
import { ReminderInput } from "./ReminderInput";

const DEFAULT_REMINDER: NonNullable<TellescopeModelFromName<"calendar_events">["reminders"]>[number] = {
  type: "enduser-notification",
  msBeforeStartTime: 24 * 60 * 60 * 1000,
  dontSendIfPassed: false,
  info: {
    channel: "Email",
  },
};

export interface RemindersSectionProps
  extends Pick<ReturnType<typeof useEventFormDialogContents>, "form" | "reminders" | "setReminders"> {}

export const RemindersSection = ({ form, reminders, setReminders }: RemindersSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <form {...form.getFormProps()} className="space-y-4">
      <div className="space-y-2">
        {reminders?.length ? (
          <div className="space-y-2">
            {reminders.map((reminder, i) => (
              <ReminderInput
                key={`reminder-input-${i}`}
                value={reminder}
                onChange={(reminder) =>
                  setReminders((prev) => prev?.map((item, index) => (index === i ? reminder : item) ?? []))
                }
                onDelete={() => setReminders((prev) => prev?.filter((_, index) => index !== i) ?? [])}
              />
            ))}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">{t("No reminders set. Add one below.")}</p>
        )}
        <Button
          variant="outline"
          className="font-light text-xs gap-1 p-1 h-auto"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setReminders((prev) => [...(prev ?? []), DEFAULT_REMINDER]);
          }}
        >
          <Plus className="size-3.5" />
          {t("Add reminder")}
        </Button>
      </div>
    </form>
  );
};
